// Tab Functionality for Product Block
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all product tab components on the page
  initProductTabs();
});

function initProductTabs() {
  const tabContainers = document.querySelectorAll('.product-tabs-container');
  
  tabContainers.forEach(function(container) {
    const tabButtons = container.querySelectorAll('.product-tab-btn');
    const tabContents = container.querySelectorAll('.product-tab-content');
    const tabButtonsWrapper = container.querySelector('.inline-flex');
    
    // Create sliding background indicator
    const indicator = document.createElement('div');
    indicator.className = 'tab-indicator';
    tabButtonsWrapper.style.position = 'relative';
    tabButtonsWrapper.insertBefore(indicator, tabButtonsWrapper.firstChild);
    
    // Function to update indicator position
    function updateIndicator(activeButton) {
      const buttonRect = activeButton.getBoundingClientRect();
      const wrapperRect = tabButtonsWrapper.getBoundingClientRect();
      
      const left = buttonRect.left - wrapperRect.left;
      const width = buttonRect.width;
      
      indicator.style.transform = `translateX(${left}px)`;
      indicator.style.width = `${width}px`;
    }
    
    // Set initial position
    const activeButton = container.querySelector('.product-tab-btn.active');
    if (activeButton) {
      // Small delay to ensure layout is ready
      setTimeout(() => updateIndicator(activeButton), 50);
    }
    
    // Setup click events for tab buttons
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab-id');
        const tabIndex = parseInt(this.getAttribute('data-tab-index') || '0');
        
        if (!tabId) return;
        
        // Update active tab button
        tabButtons.forEach(function(btnElement) {
          if (btnElement.getAttribute('data-tab-id') === tabId) {
            btnElement.classList.add('active');
          } else {
            btnElement.classList.remove('active');
          }
        });
        
        // Update indicator position
        updateIndicator(this);
        
        // Update active content
        tabContents.forEach(function(content) {
          if (content.getAttribute('data-tab-content') === tabId) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      });
    });
    
    // Update indicator on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const activeBtn = container.querySelector('.product-tab-btn.active');
        if (activeBtn) {
          updateIndicator(activeBtn);
        }
      }, 100);
    });
    
    // Initialize pagination dots for each tab
    initPaginationDots(container);
  });
}

function initPaginationDots(container) {
  const tabContents = container.querySelectorAll('.product-tab-content');
  
  tabContents.forEach(function(tabContent) {
    const carousel = tabContent.querySelector('.product-carousel');
    const paginationDots = tabContent.querySelector('.pagination-dots');
    
    if (!carousel || !paginationDots) return;
    
    const dots = paginationDots.querySelectorAll('.pagination-dot');
    const products = carousel.querySelectorAll('.flex-shrink-0');
    
    if (dots.length === 0 || products.length === 0) return;
    
    // Update active dot based on scroll position
    function updateActiveDot() {
      const scrollLeft = carousel.scrollLeft;
      const itemWidth = products[0].offsetWidth + 30; // width + gap
      const currentIndex = Math.round(scrollLeft / itemWidth);
      
      dots.forEach(function(dot, index) {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    // Handle scroll event with debounce
    let scrollTimeout;
    carousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 50);
    });
    
    // Handle dot click to scroll to specific product
    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        const itemWidth = products[0].offsetWidth + 30; // width + gap
        const scrollPosition = index * itemWidth;
        
        carousel.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      });
    });
    
    // Initialize first dot as active
    updateActiveDot();
  });
}